import React, { useContext, useState } from "react";
import { Track } from "../spotify/spotify";
import { ReactComponent as BackArrowIcon } from "../media/back_arrow.svg";
import { ThemeContext } from "../App";

interface GroupBuilderProps {
    targetSong: Track;
    songList: Track[];
    back: () => void;
    startGroup: (songs: Track[]) => void;
}

const GroupBuilder: React.FC<GroupBuilderProps> = ({ targetSong, songList, back, startGroup }) => {
    const { theme, setTheme } = useContext(ThemeContext);
    const [ addedSongs, setAddedSongs ] = useState<Track[]>([]);

    if (songList.length === 0) {
        return (
            <>
                <div className='absolute top-3 left-3 row align-center mx-bw-5 cursor-pointer' onClick={back}><BackArrowIcon /><p>Use Different Configuration</p></div>
                <p className="">No similar songs found!</p>
            </>
        )
    }

    return (
        <div className="column-centered">
            <div className='absolute top-3 left-3 row align-center mx-bw-5 cursor-pointer' onClick={back}><BackArrowIcon /><p>Use Different Configuration</p></div>
            <div className="column-centered my-3">
                { targetSong.album.images.length > 0 && <img src={targetSong.album.images[0].url} alt="img" className="album-art-cover-img my-3" /> }
                { 
                    targetSong.preview_url &&
                    <audio controls className="my-3">
                        <source src={targetSong.preview_url} type="audio/mp3" />
                    </audio>
                }
                <p className="mx-4 text-center">({songList.length}) Songs Similar to <b>{targetSong.name}</b> by <i>{targetSong.artists.map(a => a.name).join(', ')}</i>:</p>
            </div>
            <p className="my-3">Select songs to add to your group:</p>
            { addedSongs.length > 0 && <button className="" onClick={() => startGroup(addedSongs)}>Create group with {addedSongs.length + 1 } songs</button> }
            <div className="column track-list">
                { 
                    songList.map(song => {
                        const songAdded = addedSongs.some(s => s.id === song.id);
                        return (
                            <div key={song.id} className={`row align-center mx-bw-5 ${songAdded ? (theme === "dark" ? 'bg-white bg-opacity-20' : 'bg-black bg-opacity-20') : ''}`}>
                                { song.album.images.length > 0 && <img src={song.album.images[0].url} alt="img" className="album-art-img" /> }
                                <div className="flex-grow self-stretch row align-center cursor-pointer mx-bw-5 ml-1 md:ml-3" onClick={() => songAdded ? setAddedSongs(songs => songs.filter(s => s.id !== song.id)) : setAddedSongs(songs => [...songs, song])}>
                                    <p className="">{song.name} by <i>{song.artists.map(a => a.name).join(', ')}</i></p>
                                </div>
                                { 
                                    song.preview_url ?
                                    <audio controls className="ml-auto">
                                        <source src={song.preview_url} type="audio/mp3" />
                                    </audio> : 
                                    <p className="opacity-50 ml-auto">(no preview available)</p>
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default GroupBuilder;
